import { createRef, FC } from 'react';
import useOutsideClick from '../hooks/useOutsideClick';
import { menuItem } from '../utils/menu';
import IconYettelMenu from '../assets/images/icons/icon-yettel-menu.webp';
import IconHipernet from '../assets/images/icons/icon-hipernet.png';
import IconShop from '../assets/images/icons/icon-shop.png';
import IconYettelPortal from '../assets/images/icons/icon-yettel-portal.png';
import IconZeleneStaze from '../assets/images/icons/icon-zelene-staze.png';
import IconYpay from '../assets/images/icons/icon-ypay.png';
import IconYsd from '../assets/images/icons/icon-ysd.png';
import IconNalog from '../assets/images/icons/icon-nalog.png';
import IconYbank from '../assets/images/icons/icon-ybank.png';
import '../scss/yettel-menu.scss';

type Props = {
  menuItems: menuItem[];
};

const YettelMenu: FC<Props> = ({ menuItems }: Props) => {
  const detailsRef = createRef<HTMLDetailsElement>();
  useOutsideClick(detailsRef);

  const IMAGE_MAP = new Map<string, typeof IconYettelMenu>([
    ['shop', IconShop],
    ['ysd', IconYsd],
    ['ypay', IconYpay],
    ['portal', IconYettelPortal],
    ['zeleneStaze', IconZeleneStaze],
    ['hipernet', IconHipernet],
    ['ybank', IconYbank],
    ['nalog', IconNalog]
  ]);

  return (
    <div className="yettel-ecosystem-menu">
      <details ref={detailsRef} data-popover="down">
        <summary className="d-block">
          <div className="ytl-icon-container"></div>
          <img
            className="icon"
            alt="yettel-menu"
            src={IconYettelMenu}
            width={35}
          />
        </summary>
        <div className="ytl-popover-menu-list">
          {menuItems.map((item: menuItem) => {
            return (
              <a href={item.url} className="ytl-menu-item" key={item.url}>
                <img
                  className="ytl-menu-item-icon"
                  alt={item.img}
                  src={IMAGE_MAP.get(item.img)}
                />
                <div className="ytl-menu-item-text">
                  <p>{item.title}</p>
                </div>
              </a>
            );
          })}
        </div>
      </details>
    </div>
  );
};

export default YettelMenu;
